let googleMapsPromise = null
const GOOGLE_MAPS_INIT_CALLBACK_NAME = "init"

function isLoading() {
  return googleMapsPromise !== null
}

function isLoaded() {
  return window.google && window.google.maps
}

function loadScript(apiKey) {
  googleMapsPromise = new Promise((resolve, reject) => {
    setupScriptCallback(resolve)
    injectScript(apiKey, reject)
  })

  return googleMapsPromise
}

function setupScriptCallback(resolve) {
  window[GOOGLE_MAPS_INIT_CALLBACK_NAME] = () => {
    resolve(window.google)
    delete window[GOOGLE_MAPS_INIT_CALLBACK_NAME]
  }
}

function injectScript(apiKey, reject) {
  const script = createScriptElement(apiKey)

  script.onerror = () => {
    googleMapsPromise = null
    delete window[GOOGLE_MAPS_INIT_CALLBACK_NAME]
    reject(new Error("Failed to load Google Maps"))
  }

  document.head.appendChild(script)
}

function createScriptElement(apiKey) {
  const script = document.createElement("script")
  script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=marker&v=quarterly&loading=async&callback=${GOOGLE_MAPS_INIT_CALLBACK_NAME}`
  script.async = true
  script.defer = true

  return script
}

export async function loadGoogleMaps(apiKey) {
  if (isLoading()) return googleMapsPromise
  if (isLoaded()) return window.google

  return loadScript(apiKey)
}
